// extracted by mini-css-extract-plugin
export default {"LoadingOverlay":"LoadingOverlay_LoadingOverlay__PtHUX"};